import {Component, Input, OnInit} from '@angular/core';
import {DashboardBoxesHeadData} from "../../interfaces/dashboard-boxes-head-data";
import {TrophyService} from "../../services/trophy.service";
import {OrganizationTrophyData} from "../../interfaces/organization-trophy-data";
import {OrganizationTrophyItem} from "../../interfaces/organization-trophy-item";

@Component({
  selector: 'brt-organization-trophies-block',
  templateUrl: './organization-trophies-block.component.html',
  styleUrls: ['./organization-trophies-block.component.scss']
})
export class OrganizationTrophiesBlockComponent implements OnInit {

  headlineBlockData: Partial<DashboardBoxesHeadData> = {
    title: "Eure Trophäen",
    titleIcon: 'trophy',
    hint: "-1 von -1 gesammelt",
    addHintPulseCircle: true,
    color: "cyan"
  }

  totalTrophies = 0;
  completedTrophies = 0;

  organizationTrophies: OrganizationTrophyData = {
    items: []
  };

  allTrophies: OrganizationTrophyItem[] = [];

  @Input("classId") set setClassId(value: number) {
    if(value >= 0) {
      this.getClassTrophyProgress(value);
      this.classId = value;
    }
  }

  classId = -1;


  constructor(
    private trophyService: TrophyService,

  ) {
  }

  ngOnInit() {
  }

  openFullList(): void {
    this.trophyService.openTrophiesOverlay(this.classId);
  }

  getClassTrophyProgress(schoolClassId: number) {

    this.trophyService.loadClassTrophies(schoolClassId).then((data) => {
      this.organizationTrophies.items = data.items;

      this.allTrophies = this.organizationTrophies.items;

      this.totalTrophies = this.organizationTrophies.items.length;
      this.completedTrophies = this.organizationTrophies.items.filter((item) => item.percentValue === 100).length;

      this.organizationTrophies.items = this.organizationTrophies.items.sort((b, a) => a.percentValue - b.percentValue);
      this.organizationTrophies.items = this.organizationTrophies.items.slice(0, 6);

      this.headlineBlockData = {
        ...this.headlineBlockData,
        hint: `${this.completedTrophies} von ${this.totalTrophies} gesammelt`
      }

    });
  }


}
